import React, {Component} from 'react';
import C from "../Const";
import StaticScenarioEditor from "./StaticScenarioEditor";
import DynamicScenarioEditor from "./DynamicScenarioEditor";

class Scenario extends Component {
    render() {
        let scenario = "";

        if(this.props.scenario_type === 'lla'){
            scenario = <div>
                Lat: {this.props.lla[0]}, Lon: {this.props.lla[1]}, Alt: {this.props.lla[2]},
                <div>
                    <img src={Scenario.buildStaticMapUrl(this.props.lla[0], this.props.lla[1])}
                         alt="{'lla=' + this.props.lla[0]} +  {this.props.lla[1]} +  {this.props.lla[2]}}"/>
                </div>
            </div>
        }
        else if(this.props.scenario_type === 'dynamic'){
            scenario = <div>
                <div>
                    <img src={Scenario.buildDynamicMapUrl(this.props.overview_polyline)}
                         alt={this.props.overview_polyline}/>
                </div>
            </div>
        }
        else {
            scenario = <span>No scenario specified</span>;
        }
        return(
            <div>
                <button  onClick={this.props.onNewStaticClick}>New Static Scenario</button>
                <button  onClick={this.props.onNewDynamicClick}>New Dynamic Scenario</button>
                {scenario}
            </div>
        )
    }

    static buildStaticMapUrl(lat, lon ){
        let url = "https://maps.googleapis.com/maps/api/staticmap?";
        url = url + "center=" + lat + "," + lon;
        url = url + "&zoom=10";
        url = url + "&size=640x480";
        url = url + "&markers=color:|"+ lat + "," + lon;
        url = url + "&key=" + C.GOOGLE_MAP_API_KEY;
        return encodeURI(url);
    }

    static buildDynamicMapUrl(overview_polyline){
        let url = "https://maps.googleapis.com/maps/api/staticmap?";
        url = url + "path=enc:" + overview_polyline;
        url = url + "&size=640x480";
        url = url + "&key=" + C.GOOGLE_MAP_API_KEY;
        return encodeURI(url);
    }

}

class EditableScenario extends Component {

    state = {
        isStaticEditorOpened: false,
        isDynamicEditorOpened: false,
    };

    render() {

        console.log('EditableScenario props', this.props );
        console.log('EditableScenario state', this.state );

        if( this.state.isStaticEditorOpened ){
            // LLA can be undefined if the current scenario is not static
            const lla= this.props.lla || [37.872653, -122.456350, 0];
            return <StaticScenarioEditor
                {...this.props}
                lla={lla}
                onUpdated={this.scenarioWasUpdated}
            />;
        }else if( this.state.isDynamicEditorOpened ){
            // Start and Finish LLA  can be undefined if the current scenario is not dynamic
            const start_lla= this.props.start_lla || [37.872653, -122.456350, 0];
            const finish_lla= this.props.finish_lla || [37.853697, -122.478267, 0];

            return <DynamicScenarioEditor
                {...this.props}
                start_lla={start_lla}
                finish_lla={finish_lla}
                onUpdated={this.scenarioWasUpdated}
            />;
        }else{
            return <Scenario
                {...this.props}
                onNewStaticClick={this.editStaticScenario}
                onNewDynamicClick={this.editDynamicScenario}
            />;
        }
    }

    editStaticScenario = () => {
        this.setState({
            isStaticEditorOpened: true,
        });
    };

    editDynamicScenario = () => {
        this.setState({
            isDynamicEditorOpened: true,
        });
    };

    scenarioWasUpdated = () => {
        this.setState({
            isStaticEditorOpened: false,
            isDynamicEditorOpened: false,
        });
        console.log("Scenario has been updated");
        this.props.onChange();
    };
}

export default EditableScenario;
